import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const ADMIN_FLAG = "mb_is_admin";

export const MONTHS_IT = [
  "gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno",
  "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre",
];

export const LOGO = "https://minimebaby.it/cdn/shop/files/Logo_Minime_1.png?v=1787306753&width=400";

export const IMAGES = {
  hero: "https://minimebaby.it/cdn/shop/files/photo_5841676094531113181_y.jpg?width=1600",
  twins: "https://minimebaby.it/cdn/shop/files/minime.png?v=1789728294&width=1600",
  flatlayPink: "https://minimebaby.it/cdn/shop/files/minime.png?v=1789728294&width=1600",
  motherHolding: "https://minimebaby.it/cdn/shop/files/photo_5841676094531113181_y.jpg?width=1600",
  nursery: "https://minimebaby.it/cdn/shop/files/photo_5841676094531113181_y.jpg?width=1600",
  rack: "https://minimebaby.it/cdn/shop/files/minime.png?v=1789728294&width=1600",
};
